import { render, staticRenderFns } from "./messageDash.vue?vue&type=template&id=4ce599da&"
import script from "./messageDash.vue?vue&type=script&lang=js&"
export * from "./messageDash.vue?vue&type=script&lang=js&"
import style0 from "./messageDash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports